export default __webpack_public_path__ + "static/media/Belt of the Usurper.15c8ab02.jpg";